import { render, staticRenderFns } from "./IconSvgXml.vue?vue&type=template&id=27f4a906&scoped=true&"
import script from "./IconSvgXml.vue?vue&type=script&lang=js&"
export * from "./IconSvgXml.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f4a906",
  null
  
)

export default component.exports